import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

import { ActionNavBody, ActionNavSearch } from './components';

import './ActionNav.scss';

const ActionNav = ({
  children,
  className,
  onSearchClear,
  onSearchExecute,
  onSearchInputChange,
  searchData,
  searchPlaceholder,
  shouldAllowWrapping,
  shouldHideMobileMenuToggle,
  noBorder,
}) => (
  <div
    className={clsx(className, 'action-nav', {
      'action-nav--no-border': noBorder,
      'allows-wrapping': shouldAllowWrapping,
      'hide-mobile-menu': shouldHideMobileMenuToggle,
    })}
  >
    {children && (
      <ActionNavBody searchData={searchData} searchPlaceholder={searchPlaceholder}>
        {children}
      </ActionNavBody>
    )}
    <ActionNavSearch
      onSearchClear={onSearchClear}
      onSearchExecute={onSearchExecute}
      onSearchInputChange={onSearchInputChange}
      searchData={searchData}
    />
  </div>
);

ActionNav.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  noBorder: PropTypes.bool,
  onSearchClear: PropTypes.func,
  onSearchExecute: PropTypes.func,
  onSearchInputChange: PropTypes.func,
  searchData: PropTypes.shape({
    execute: PropTypes.number,
    keyword: PropTypes.string,
  }),
  searchPlaceholder: PropTypes.string,
  shouldAllowWrapping: PropTypes.bool,
  shouldHideMobileMenuToggle: PropTypes.bool,
};

ActionNav.defaultProps = {
  children: undefined,
  className: undefined,
  noBorder: undefined,
  onSearchClear: undefined,
  onSearchExecute: undefined,
  onSearchInputChange: undefined,
  searchData: undefined,
  searchPlaceholder: 'Results',
  shouldAllowWrapping: undefined,
  shouldHideMobileMenuToggle: undefined,
};

export default ActionNav;
